



import ShowPreviewComponent from "@/components/admin/show/showPreviewComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "ShowPreviewPage",
  components: {
    ShowPreviewComponent,
  },
})
export default class ShowPreviewPage extends Vue {}
